export enum Role {
  ADMIN = 'admin',
  PREMIUM = 'premium',
  DATA_OPERATOR = 'data-operator',
  USER_MANAGER = 'user-manager',
  FREE = 'free',
  ORGANIZATION = 'organization',
}